export const POST_LIST_ACTION = "POST_LIST_ACTION";
export const POST_LIST_SUCCESS = "POST_LIST_SUCCESS";
export const POST_LIST_FAIL = "POST_LIST_FAIL";
export const POST_DETAIL_ACTION = "POST_DETAIL_ACTION";
export const POST_DETAIL_SUCCESS = "POST_DETAIL_SUCCESS";
export const POST_DETAIL_FAIL = "POST_DETAIL_FAIL";
export const POST_FAIL = "POST_FAIL";
export const POST_DETAIL_UPDATE_ACTION = "POST_DETAIL_UPDATE_ACTION";
export const POST_DETAIL_CREATE_ACTION = "POST_DETAIL_CREATE_ACTION";
export const POST_DETAIL_DELETE_ACTION = "POST_DETAIL_DELETE_ACTION";

export const POST_CREATE_TRANSLATE_ACTION = "POST_CREATE_TRANSLATE_ACTION";
export const POST_CREATE_TRANSLATE_SUCCESS = "POST_CREATE_TRANSLATE_SUCCESS";

export const POST_UPDATE_TRANSLATE_ACTION = "POST_UPDATE_TRANSLATE_ACTION";
export const POST_UPDATE_TRANSLATE_SUCCESS = "POST_UPDATE_TRANSLATE_SUCCESS";

export const POST_DELETE_TRANSLATE_ACTION = "POST_DELETE_TRANSLATE_ACTION";
export const POST_DELETE_TRANSLATE_SUCCESS = "POST_DELETE_TRANSLATE_SUCCESS";